/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['../../../lib/@waca/core-client/js/core-client/ui/core/View'],
	function(View) {
		var PlaceholderView = null;

		PlaceholderView = View.extend({
			init: function() {
				PlaceholderView.inherited('init', this, arguments);
			},

			hide: function() {
				this.$el.find('.placeholder').hide();
				this._isShowing = false;
			},

			show: function() {
				this.$el.find('.placeholder').show();
				this._isShowing = true;
			},

			isShowing: function() {
				return this._isShowing;
			}
		});

		return PlaceholderView;
	});
